<template>
	<!-- sidebar-fixed -->
	<nav class="sidebar sidebar-offcanvas" id="sidebar" style="background-color: #0D283F;border-right: 1px solid #007297;">
		<ul class="navul">
			<li v-for="(item,index) in menuList" @click="onMenuActive(item.url)" >
				<router-link class="nav-link" to="">
					<!-- <img :src="menuActive==index?item.actIcon:item.defIcon" :alt="item.title"> -->
					<span :class="menuActive==item.url?'activev':''">{{item.title}}</span>
				</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				menuActive: '/index',
				menuList: [{
					title: '首页',
					url: '/index',
					defIcon: require('../../assets/images/mo1.png'),
					actIcon: require('../../assets/images/mo2.png'),
				},{
					title: '设备列表',
					url: '/deviceList',
					defIcon: require('../../assets/images/mo1.png'),
					actIcon: require('../../assets/images/mo2.png'),
				},{
					title: '检测记录',
					url: '/testRecord',
					defIcon: require('../../assets/images/mo1.png'),
					actIcon: require('../../assets/images/mo2.png'),
				}],
			}
		},
		computed: {
			roleMenus() {
				return this.$store.state.roleMenus
			},
		},
		mounted() {
			let _this = this;
			let menustr = sessionStorage.getItem('menuActive');
			_this.menuActive = menustr == null ? 1 : menustr;
			_this.menuActive=this.$route.path;
			// let rolelist = _this.roleMenus;
			// for (let items of rolelist) {
			// 	for (let item in _this.menuList) {
			// 		if (items.code == _this.menuList[item].code) {
			// 			_this.menuList[item].roleList = items.menus;
			// 			_this.menuList[item].show = items.checked;
			// 			break;
			// 		}
			// 	}
			// }
			// _this.$store.commit('onRoleMenus', {
			// 	list: _this.menuList[_this.menuActive].roleList
			// });
		},
		methods: {
			onMenuActive: function(index) {
				let _this = this;
				_this.menuActive = index;
				sessionStorage.setItem('menuActive', index);
				
				_this.$router.push(index);


			}
		},
	}
</script>

<style lang="scss">
	.navul {
		list-style: none;
		padding: 0px;

		li {
			text-align: center;
			border-bottom:1px solid rgba(0, 114, 151,.5);
			
			img {
				width: 30px;
				margin: 20px 26px 10px;
			}

			.nav-link {
				color: white;
				line-height: 30px;
				padding: 8px 10px !important;
			}

			span {
				// font-family: fangsong;
				font-size: 14px;
			}

			.activev {
				color: #51F3F7;
			}
			&:hover{
				background-color: #121C2B;
			}
		}
	}
</style>
